export const environment = {
  production: true,
  apiUrl: 'https://apimdb.marideal.mu/api/',
  apiUrlMofluid: 'https://api1m.marideal.mu/',
  tokenShard1: 'fOEmcLBjaI8997866453)!(>*ljOM&%j',
  tokenShard2: '17497991218546549666373042315947'
}
